export enum API {
  APPROVAL_HUB = '/api/x_isgi_isg_governa/appoval_hub_new',
  ATTACHMENT = '/api/now/table/sys_attachment',
  UPLOAD_ATTACHMENT = '/api/now/attachment/file',
}